import { cva } from "cva";
import Image from "next/image";
import React from "react";
import {
  NewsletterSignupForm,
  NewsletterSignupFormProps,
} from "~/landing-pages/components/Newsletter/NewsletterSignupForm";
import {
  backgroundColorStyle,
  primaryTextColorStyle,
  secondaryTextColorStyle,
} from "~/landing-pages/shared-landing-page-styles";
import { Body, Headline } from "~/ui-library";

export type NewsletterSignupProps = {
  appearance: "brand" | "dark" | "light";
  blockIndex: number;
  description: string;
  imageSrc: string | null;
  title: string;
  variant: "inline_center" | "side_by_side";
} & Pick<NewsletterSignupFormProps, "iterableListId" | "newsletterSlug">;

const containerStyles = cva("mx-auto grid", {
  defaultVariants: {
    variant: "inline_center",
  },
  variants: {
    variant: {
      inline_center: "w-full self-center px-4 lg:max-w-[700px]",
      side_by_side:
        "grid-cols-1 gap-0 px-4 lg:max-w-[950px] lg:grid-cols-12 lg:gap-8 lg:px-8",
    },
  },
});

const formStyle = cva("", {
  defaultVariants: {
    variant: "inline_center",
  },
  variants: {
    variant: {
      inline_center: "col-span-12",
      side_by_side: "lg:col-span-6",
    },
  },
});

export const NewsletterSignup: React.FC<NewsletterSignupProps> = ({
  appearance,
  description,
  imageSrc,
  title,
  variant,
  ...formProps
}) => (
  <div
    className={backgroundColorStyle({
      appearance,
      className: "relative py-12 sm:py-16 lg:py-24",
    })}
  >
    {imageSrc ? (
      <Image alt="" className="z-10 object-cover" fill src={imageSrc} />
    ) : null}
    <div
      className={containerStyles({
        className: "relative z-20",
        variant,
      })}
    >
      <div className="max-w-md lg:col-span-6">
        <Headline
          as="h2"
          level={2}
          mdLevel={1}
          className={primaryTextColorStyle({
            appearance,
            className: "mb-xs",
          })}
        >
          {title}
        </Headline>
        <Body
          className={secondaryTextColorStyle({
            appearance,
          })}
          size="large"
        >
          {description}
        </Body>
      </div>
      <NewsletterSignupForm
        {...formProps}
        appearance={appearance}
        className={formStyle({ className: "mt-s", variant })}
      />
    </div>
  </div>
);
